<template>
  <div class="d-flex justify-end" :class="$root.isMobile ? 'flex-column' : ''">
    <v-btn
      depressed
      outlined
      tile
      color="primary"
      :class="$root.isMobile ? 'mt-3' : 'ml-3'"
      :width="$root.isMobile ? '100%' : '140px'"
      @click="$router.push('/templates')"
    >
      Close
    </v-btn>
    <template>
      <v-btn
        v-if="isDelete && isAdmin"
        tile
        depressed
        outlined
        color="error"
        :class="$root.isMobile ? 'mt-3' : 'ml-3'"
        :width="$root.isMobile ? '100%' : '140px'"
        @click="confirm = true"
      >
        Delete
      </v-btn>
      <v-btn
        v-if="isAdmin || isDataEntry || isDataEntryAndDispatcher"
        depressed
        tile
        class="success"
        :class="$root.isMobile ? 'mt-3' : 'ml-3'"
        :width="$root.isMobile ? '100%' : '140px'"
        @click="$emit('save')"
      >
        Save
      </v-btn>
    </template>
    <Confirm
      :message="message"
      v-if="confirm"
      @close="confirm = false"
      @click="open"
    ></Confirm>
  </div>
</template>

<script>
import Confirm from "../../Confirm";
export default {
  props: {
    type: {
      type: Number,
      default: 0
    }
  },
  components: {
    Confirm
  },
  data() {
    return {
      confirm: false,
      message: "Are you sure you want to Delete this template?"
    };
  },
  computed: {
    isDelete() {
      let name = this.$route.name;
      let check = this.type === 0 && name === "template-update";
      return check;
    }
  },
  methods: {
    open() {
      const vm = this;
      vm.confirm = false;
      vm.$emit("remove");
    }
  }
};
</script>

<style></style>
